export default __webpack_public_path__ + "static/media/dropdown-arrow.d867bf1f.svg";